import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Typography } from '@mui/material';
/**
 * Middle Line
 * @param {any} props
 * @returns {ReactElement}
 */
export const MiddleLineSG = function (props) {
    const { children, xstyles } = props;
    return (_jsx(Typography
    // Customized middle line
    , Object.assign({ 
        // Customized middle line
        sx: Object.assign({ '&': {
                overflow: 'hidden',
                textAlign: 'center',
                fontWeight: '400',
                fontSize: '0.75rem',
                lineHeight: '1rem',
                color: '#000000',
                padding: '0 0 1rem',
            }, '&:before, &:after': {
                backgroundColor: '#C0C9C1',
                content: '""',
                display: 'inline-block',
                height: '1px',
                position: 'relative',
                verticalAlign: 'middle',
                width: '50%',
            }, '&:before': {
                right: '0.5em',
                marginLeft: '-50%',
            }, '&:after': {
                left: '0.5em',
                marginRight: '-50%',
            } }, xstyles) }, { children: children })));
};
